// extracted by mini-css-extract-plugin
export default {"Container":"qrCard_Container__NkNvM","Card":"qrCard_Card__H2nI2","Image":"qrCard_Image__Dh8Np","Bold":"qrCard_Bold__Fqx+l","Small":"qrCard_Small__plvlq"};